import { render } from "./BoardDetailMainContents.vue?vue&type=template&id=481575f0&scoped=true"
import script from "./BoardDetailMainContents.vue?vue&type=script&lang=js"
export * from "./BoardDetailMainContents.vue?vue&type=script&lang=js"

import "./BoardDetailMainContents.vue?vue&type=style&index=0&id=481575f0&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-481575f0"

export default script